import styled from '@emotion/styled';
import React from 'react';
import { getFormattedPrice } from '../../../../../shared/i18n/price/utils/getFormattedPrice';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { INewBooking } from '../../../../domain/booking/models/INewBooking';
import { Price } from '../../../../../shared/i18n/price/Price';
import { Color } from '../../../../../shared/styles/Color';

interface IBookingSummarySavingsProps {
	booking: INewBooking;
}

export const BookingSummarySavings = ({
	booking,
}: IBookingSummarySavingsProps) => {
	const { t } = useTranslation();
	if (!booking.parkingProduct) return null;

	const { onlineSavings } = booking.parkingProduct.price;
	const savings = new Price({
		currencyCode: onlineSavings.currencyCode,
		centAmount: onlineSavings.centAmount,
	});

	if (!savings.centAmount) return null;

	return (
		<StyledSummaryLabelPrice>
			<StyledLabel>{t('web_booking_summary_savings')}</StyledLabel>
			<StyledPrice>{`-${getFormattedPrice(savings)}`}</StyledPrice>
		</StyledSummaryLabelPrice>
	);
};

export const StyledSummaryLabelPrice = styled.div`
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	margin-top: 12px;
`;

export const StyledLabel = styled.span`
	font-size: 20px;
	font-weight: 700;
`;

export const StyledPrice = styled.span`
	color: ${Color.ErrorDark};
`;
